export default function authHeader() {
  const storeUser = localStorage.getItem('user')
    const user = JSON.parse(storeUser);    
    if (user && user.access_token) {
      return {   
        'Authorization': 'Bearer ' + user.access_token 
      };
    } else {
      return {};
    }
    
  }